export default __webpack_public_path__ + "static/media/GameResult.8df61779.png";